import { NavTab, PageNav } from "@ugg/shared/components/common/PageNav";
import { getDeadlockDataName } from "lib/general-helper";

interface BuildsNavProps {
  heroName: string;
}

const BuildNav = (props: BuildsNavProps) => {
  let urlHeroName = getDeadlockDataName(props.heroName);
  if (urlHeroName === "mo_&_krill") {
    urlHeroName = "mo_and_krill";
  }
  const rootPathName = `/deadlock/heroes/${urlHeroName}`;

  const navLinks: NavTab[] = [
    { label: "Build", to: `${rootPathName}/build` },
    { label: "Item Tier List", soon: true },
    { label: "Matchups", soon: true },
  ];

  return <PageNav tabs={navLinks} />;
};

export default BuildNav;
